import React, { useRef } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { push } from 'react-router-redux';
import { Formik } from 'formik';

// Components
import ExtComp from '../../components/external';
import NewJobWrapper from '../../components/NewJobWrapper/NewJobWrapper';
import RadioBtnRow from '../../components/RadioEl/RadioBtnRow';
import RadioBtnItem from '../../components/RadioEl/RadioBtnItem';

// Actions
import { setInfo } from '../../reducer/createNewJobActions';

// Style
import s from './NewJobOptions.style';


const NewJobOptions = (props) => {
  const { t, dispatch, info } = props;
  const formRef = useRef();

  const onSubmit = () => {
    dispatch(setInfo(formRef.current.values));
    dispatch(push('/practitioner/new-job/select-appointments'));
  };

  return (
    <NewJobWrapper
      screenTitle={t('nj_job_information')}
      percent={25}
      nextBtnAction={onSubmit}
    >

      <Formik innerRef={formRef} initialValues={info} >
        {(formProps) => {
          const { values, handleChange, setFieldValue } = formProps;

          return (
            <s.OptionsWrapper>

              {/* ──── Select type ─────────────────────────────────────────────────────────────────────── */}
              <section className="section">
                <h3 className="section-title">{t('nj_select_job_type')}</h3>

                <RadioBtnRow
                  disabled
                  name="type"
                  id="job-type-cancel"
                  title={t('nj_mass_cancel')}
                  subTitle={t('nj_mass_cancel_short_title')}
                  value="cancel"
                  checked={values.type === 'cancel'}
                  onChange={handleChange}
                />
                <RadioBtnRow
                  name="type"
                  id="job-type-communicate"
                  title={t('nj_mass_communicate')}
                  subTitle={t('nj_mass_communicate_short_title')}
                  value="communicate"
                  checked={values.type === 'communicate'}
                  onChange={handleChange}
                />
                <RadioBtnRow
                  disabled // ONLY FOR AZMONICA
                  name="type"
                  id="job-type-reschedule"
                  title={t('nj_mass_reschedule')}
                  subTitle={t('nj_mass_reschedule_short_title')}
                  value="reschedule"
                  checked={values.type === 'reschedule'}
                  onChange={handleChange}
                />
              </section>

              {/* ──── Manually or filters ──────────────────────────────────────────────────────────────── */}
              <section className="section">
                <h3 className="section-title">{t('nj_select_appoints_type_caption')}</h3>

                <div className="radio-items-wrapper">
                  <RadioBtnItem
                    name="isManual"
                    id="selection-type-manual"
                    rightLabel={t('nj_select_appoints_type_option_1')}
                    checked={values.isManual}
                    onChange={() => { setFieldValue('isManual', true); }}
                  />
                  <RadioBtnItem
                    name="isManual"
                    id="selection-type-filter"
                    rightLabel={t('nj_select_appoints_type_option_2')}
                    checked={!values.isManual}
                    onChange={() => { setFieldValue('isManual', false); }}
                    disabled
                  />
                </div>
              </section>

              {/* ──── Start time ──────────────────────────────────────────────────────────────────────── */}
              <section className="section">
                <h3 className="section-title">{t('nj_start_job_time_caption')}</h3>

                <div className="radio-items-wrapper">
                  <RadioBtnItem
                    name="runTime"
                    id="time-type-1"
                    rightLabel={t('nj_start_job_time_option_1')}
                    checked={!values.runTime}
                    onChange={() => { setFieldValue('runTime', null); }}
                  />
                  <RadioBtnItem
                    disabled
                    name="runTime"
                    id="time-type-2"
                    rightLabel={t('nj_start_job_time_option_2')}
                    checked={!!values.runTime}
                    onChange={() => { setFieldValue('runTime', moment()); }}
                  />
                </div>


                <div className="time-pickers">
                  <div className="date-picker-wrapper">
                    <ExtComp.DataPicker
                      readOnly
                      disabled={!values.runTime}
                      label={t('select_date')}
                      selected={values.runTime}
                      dateFormat="DD.MM.YYYY dddd"
                      minDate={moment().startOf('day')}
                      onChange={date => {
                        setFieldValue('runTime', date);
                      }}
                    />
                  </div>

                  <div className="clock-picker">
                    <p className="label">{t('select_time')}</p>
                    <div className="timers">
                      <ExtComp.TimePicker
                        disabled={!values.runTime}
                        id="run-hour"
                        showMinute={false}
                        showSecond={false}
                        value={values.runTime}
                        onChange={date => {
                          setFieldValue('runTime', values.runTime.hour(date.format('HH')));
                        }}
                      />
                      <span className="delimiter">:</span>
                      <ExtComp.TimePicker
                        disabled={!values.runTime}
                        id="run-minutes"
                        showHour={false}
                        showSecond={false}
                        minuteStep={5}
                        value={values.runTime}
                        onChange={date => {
                          setFieldValue('runTime', values.runTime.minutes(date.format('mm')));
                        }}
                      />
                    </div>
                  </div>
                </div>

              </section>
            </s.OptionsWrapper>
          );
        }
        }
      </Formik>
    </NewJobWrapper>
  );
};

const mapStateToProps = (store) => ({
  info: store.practitioner.createNewJob.info
});

export default translate()(
  connect(mapStateToProps)(NewJobOptions)
);
